import { render, staticRenderFns } from "./DataManagementAdd.vue?vue&type=template&id=b269e34e&scoped=true"
import script from "./DataManagementAdd.vue?vue&type=script&lang=js"
export * from "./DataManagementAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b269e34e",
  null
  
)

export default component.exports